import React, { useEffect, useState } from 'react';
import BrandsList from './brands-list';
import PageHeaderText from 'components/base/page-header-text';
import useDashboardContext from 'contexts/dashboard.context';
import RecentActivities from 'components/recent-activities';
import AccessDenied from 'components/access-denied';

const Overview = () => {
  const { setRightSection, setIsRightSectionWide, activeCokitchen, permissions } =
    useDashboardContext();
  const [addNewBrand, setAddNewBrand] = useState(false);

  useEffect(() => {
    setRightSection(<RecentActivities />);
    setIsRightSectionWide(true);
    return () => {
      setRightSection(null);
      setIsRightSectionWide(false);
    };
  }, []);
  const handleEditKitchenBrands = () => {
    setAddNewBrand(!addNewBrand);
  };

  const canAccessOverview = permissions.canAccessOverview;
  if (!canAccessOverview) return <AccessDenied />;

  return (
    <div>
      <div className='flex justify-between'>
        <PageHeaderText title='Welcome' />

        {activeCokitchen.cokitchen_type === 'pop' && (
          <button
            className='border border-[#E7E8E9] shadow text-[#5C5F64] w-[86px] h-[40px] py-2 rounded-[8px]'
            onClick={handleEditKitchenBrands}>
            Edit
          </button>
        )}
      </div>
      <BrandsList editKitchenBrands={addNewBrand} setEditKitchenBrands={handleEditKitchenBrands} />
    </div>
  );
};

export default Overview;
